import React, { useMemo, useState } from 'react';
import styles from './photos.module.css';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import AttachmentThumb from '../../../../../components/patient-attachments/AttachmentThumb';
import AttachmentViewerPopup from '../../../../../components/patient-attachments/AttachmentViewerPopup';
import { getPlagiocephalySeverity } from '../cranialSeverity';
import { CRANIAL_PHOTO_VIEWS, buildBeforeAfterPairs } from './cranialPhotoViews';

const THUMB_SIZE = 120;

/**
 * Antes e depois: um cartão por vista (mais o grupo "Sem vista"), com a foto da
 * primeira medição fotografada e a da mais recente, lado a lado, com a data e o
 * CVAI de cada ponta. Enquanto só existe uma medição com foto daquela vista, o
 * lado "Antes" fica aguardando a próxima medição.
 */
const CranialPhotoCompare = ({ entries, photos, enabled, onChanged }) => {
    const [selected, setSelected] = useState(null);

    const pairs = useMemo(() => buildBeforeAfterPairs(entries, photos), [entries, photos]);

    if (pairs.length === 0) return null;

    function viewerHideHandler(changed) {
        setSelected(null);

        if (changed && onChanged) onChanged();
    }

    function openHandler(pair, item) {
        const list = [pair.before, pair.current]
            .filter(Boolean)
            .map(value => value.photo);

        setSelected({ photo: item.photo, list: list });
    }

    function PairSlot({ pair, item, badge }) {
        if (!item) {
            return (
                <Box className={styles.pairSlot}>
                    <span className={styles.pairBadge}>{badge}</span>

                    <Box className={styles.pairPlaceholder}>Aguardando próxima medição</Box>
                </Box>
            );
        }

        const [cvai] = getPlagiocephalySeverity(item.entry);

        return (
            <Box className={styles.pairSlot}>
                <span className={styles.pairBadge}>{badge}</span>

                <AttachmentThumb
                    attachment={item.photo}
                    size={THUMB_SIZE}
                    onClick={() => openHandler(pair, item)}
                />

                <span className={styles.pairDate}>{dayjs(item.entry.createdAt).format('DD/MM/YYYY')}</span>
                <span className={styles.pairValue}>{`CVAI ${cvai}%`}</span>
            </Box>
        );
    }

    return (
        <Box className={styles.pairs}>
            {pairs.map(pair => (
                <Box key={pair.view || 'none'} className={styles.pairCard}>
                    <span className={styles.pairTitle}>{pair.viewLabel}</span>

                    <Box className={styles.pairRow}>
                        <PairSlot pair={pair} item={pair.before} badge="Antes" />
                        <PairSlot pair={pair} item={pair.current} badge="Atual" />
                    </Box>
                </Box>
            ))}

            {selected && (
                <AttachmentViewerPopup
                    attachment={selected.photo}
                    list={selected.list}
                    enabled={enabled}
                    viewOptions={CRANIAL_PHOTO_VIEWS}
                    OnHide={viewerHideHandler}
                />
            )}
        </Box>
    );
};

export default CranialPhotoCompare;
